/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component } from "@angular/core";
import { AbstractModalComponent } from "../commondialog/abstract-modal.component";
import { Logger } from "@html-core";

@Component({
   standalone: false,
   selector: "osl-dialog",
   templateUrl: "./osl-dialog.component.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 600px;
         }
      `
   ]
})
export class OSLDialogComponent extends AbstractModalComponent {
   private static readonly GET_OSL_CONTENT_FAILED = "get open_source_licenses.txt content failed";
   public oslContent: string;
   constructor() {
      super();
      this.renderOSLTxt();
   }

   private readTxtFromRoot = (fileName: string): Promise<string> => {
      return new Promise((resolve, reject) => {
         if (!fileName.endsWith(".txt")) {
            return reject("Only .txt files are allowed");
         }
         chrome.runtime.getPackageDirectoryEntry(function (root) {
            root.getFile(
               fileName,
               {},
               function (fileEntry) {
                  fileEntry.file(function (file) {
                     const reader = new FileReader();
                     reader.onloadend = function (e: any) {
                        resolve(e.target.result);
                     };
                     reader.readAsText(file);
                  }, reject);
               },
               reject
            );
         });
      });
   };

   public renderOSLTxt = () => {
      this.readTxtFromRoot("open_source_licenses.txt")
         .then((content) => {
            this.oslContent = content;
         })
         .catch((err) => {
            Logger.exception(err);
            Logger.debug("cannot get open_source_licenses.txt content");
            this.oslContent = OSLDialogComponent.GET_OSL_CONTENT_FAILED;
         });
   };
}
